import React, {Component} from "react";
import ExtensionAdmin from "./ExtensionAdminView";
import {CatalogService} from "../../../service/catalog/CatalogService";
import {ExtensionAdminService} from "../../../service/operation/extensionAdmin/ExtensionAdminService";
import {Button} from "primereact/button";
import {
    CONFIRM_EXTENSION_ADMIN_ROUTE,
    EXTENSION_ADMIN_ROUTE,
    INSERT_EXTENSION_ADMIN_ROUTE
} from "../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";

export default class ExtensionAdminContainer extends Component {
    constructor(props) {
        super(props);
        this.extensionAdminService = new ExtensionAdminService();
        this.catalogService = new CatalogService();

        this.loading = this.loading.bind(this);
        this.saveFilters = this.saveFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.getInstitutionCatalog = this.getInstitutionCatalog.bind(this);
        this.getProrrogaAdmin = this.getProrrogaAdmin.bind(this);
        this.extensionActionTemplate = this.extensionActionTemplate.bind(this);

        this.state = {
            isLoading: true,
            catInstitutionCatalog: this.getInstitutionCatalog(),
            catInstitutionLenderFilter: '',
            catInstitutionBorrowerFilter: '',
            extensionAdminList: [],
        }

        this.getProrrogaAdmin();
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    saveFilters(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    clearFilters() {
        this.setState({
            catInstitutionLenderFilter: '',
            catInstitutionBorrowerFilter: '',
            isAdmin: true,
        })
    }

    getProrrogaAdmin() {
        this.loading();
        this.extensionAdminService.getProrrogaAdmin(
            this.state.catInstitutionLenderFilter,
            this.state.catInstitutionBorrowerFilter
        ).then(
            res => {
                this.setState({
                    isLoading: false,
                    extensionAdminList: res,
                })
            }
        )
    }

    getInstitutionCatalog() {
        this.loading();
        this.catalogService.getInstitutionCatalog().then(
            res => {
                this.setState({
                    isLoading: false,
                    catInstitutionCatalog: res,
                })
            }
        )
    }

    extensionActionTemplate(rowData, column) {
        let labelButton = rowData['statusPV'] === "V" || rowData['statusPV'] === "VA" ? "Insertar Prórroga" : "Confirmar o Rechazar";

        return (<Button type="button" label={labelButton} style={{marginRight: '3em'}}
                        onClick={() =>
                            this.redirectExtensionAdmin(rowData)}
        />);

    }

    redirectExtensionAdmin(rowData) {
        let path = rowData['statusPV'] === "V" || rowData['statusPV'] === "VA" ? INSERT_EXTENSION_ADMIN_ROUTE : CONFIRM_EXTENSION_ADMIN_ROUTE;

        this.props.history.push({
            pathname: path,
            state: {
                returnPath: EXTENSION_ADMIN_ROUTE,
                isAdmin: true,
                loanId: rowData['idFolioPrest'],
            },
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <ExtensionAdmin
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            catInstitutionCatalog={this.state.catInstitutionCatalog}
            catInstitutionLenderFilter={this.state.catInstitutionLenderFilter}
            catInstitutionBorrowerFilter={this.state.catInstitutionBorrowerFilter}
            saveFilters={this.saveFilters}
            clearFilters={this.clearFilters}
            getProrrogaAdmin={this.getProrrogaAdmin}
            extensionAdminList={this.state.extensionAdminList}
            extensionActionTemplate={this.extensionActionTemplate}
        />
    }
};